var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#5C0984",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62004 14.0867C6.49337 14.0867 6.3667 14.04 6.2667 13.94C6.07337 13.7467 6.07337 13.4267 6.2667 13.2334L14.2334 5.2667C14.4267 5.07337 14.7467 5.07337 14.94 5.2667C15.1334 5.46004 15.1334 5.78004 14.94 5.97337L6.97337 13.9467C6.88004 14.04 6.7467 14.0867 6.62004 14.0867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 15.6866C11.2733 15.6866 11.1466 15.64 11.0466 15.54C10.8533 15.3466 10.8533 15.0266 11.0466 14.8333L11.8466 14.0333C12.0399 13.84 12.3599 13.84 12.5533 14.0333C12.7466 14.2266 12.7466 14.5466 12.5533 14.74L11.7533 15.54C11.6599 15.6333 11.5333 15.6866 11.3999 15.6866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1933 13.8933C13.0666 13.8933 12.9399 13.8466 12.8399 13.7466C12.6466 13.5533 12.6466 13.2333 12.8399 13.04L14.4333 11.4466C14.6266 11.2533 14.9466 11.2533 15.1399 11.4466C15.3333 11.64 15.3333 11.96 15.1399 12.1533L13.5466 13.7466C13.4533 13.84 13.3199 13.8933 13.1933 13.8933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 18.1667C10.7467 18.1667 10.0934 17.7667 9.30002 16.9734L6.02669 13.7C4.43336 12.1067 4.44002 11.08 6.04669 9.47336L10.4734 5.04669C12.08 3.44002 13.1067 3.43336 14.7 5.02669L17.9734 8.30002C19.5667 9.89336 19.56 10.92 17.9534 12.5267L13.5267 16.9534C12.72 17.76 12.06 18.1667 11.4 18.1667ZM12.6 4.83336C12.2534 4.83336 11.8134 5.12002 11.18 5.75336L6.75336 10.18C6.12002 10.8134 5.83336 11.2534 5.83336 11.5934C5.83336 11.94 6.10002 12.36 6.73336 12.9934L10.0067 16.2667C10.64 16.9 11.0534 17.1667 11.4 17.1667C11.4 17.1667 11.4 17.1667 11.4067 17.1667C11.7534 17.1667 12.1867 16.88 12.82 16.2467L17.2467 11.82C17.88 11.1867 18.1667 10.7467 18.1667 10.4067C18.1667 10.06 17.9 9.64002 17.2667 9.00669L13.9934 5.73336C13.3667 5.10002 12.9467 4.83336 12.6 4.83336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 18.1666H5.33337C5.06004 18.1666 4.83337 17.94 4.83337 17.6666C4.83337 17.3933 5.06004 17.1666 5.33337 17.1666H18.6667C18.94 17.1666 19.1667 17.3933 19.1667 17.6666C19.1667 17.94 18.94 18.1666 18.6667 18.1666Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c76acbd05bdc2451f1974a8473dbbd75.svg";
export { ForwardRef as ReactComponent };